export function normalizeNotification(notification) {
    if (!notification) {
        return null
    }

    if (notification.data && typeof notification.data === 'object') {
        return {
            id: notification.id,
            type: notification.type,
            data: notification.data,
            status: notification.status || 'pending',
            read_at: notification.read_at || null,
            action_taken_at: notification.action_taken_at || null,
            created_at: notification.created_at,
            is_today:
                notification.is_today !== undefined
                    ? notification.is_today
                    : isToday(notification.created_at),
        }
    }

    return {
        id: notification.id,
        type: notification.type,
        data: notification,
        status: notification.status || 'pending',
        read_at: notification.read_at || null,
        action_taken_at: notification.action_taken_at || null,
        created_at: notification.created_at || new Date().toISOString(),
        is_today: true,
    }
}

export function isToday(dateString) {
    if (!dateString) {
        return false
    }

    const date = new Date(dateString)
    const today = new Date()

    return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
    )
}

export function isPendingNotification(notification) {
    return notification.status === 'pending'
}

export function isActionableNotification(notification) {
    return notification.status === 'pending' && !isExpiredInvite(notification)
}

export function isExpiredInvite(notification) {
    if (notification.status === 'expired') {
        return true
    }

    if (notification.type === 'App\\Notifications\\InviteToMatchNotification') {
        const createdAt = new Date(notification.created_at)
        const now = new Date()
        const fifteenMinutesInMs = 15 * 60 * 1000
        return now - createdAt > fifteenMinutesInMs
    }

    return false
}
